import { Component } from '@theme/component';

class TabbedCarouselComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#activeIndex = 0;
  }

  #activeIndex = 0;

  switchTab(data, event) {
    const index = typeof data === 'object' ? data : Number(data);
    if (index === this.#activeIndex) return;

    const { tabs, panels, ctaLinks } = this.refs;
    if (!tabs || !panels) return;

    // Deactivate current tab
    const currentTab = tabs[this.#activeIndex];
    const currentPanel = panels[this.#activeIndex];
    if (currentTab) {
      currentTab.classList.remove('hb-tabbed-carousel__tab--active');
      currentTab.setAttribute('aria-selected', 'false');
      currentTab.setAttribute('tabindex', '-1');
    }
    if (currentPanel) {
      currentPanel.classList.remove('hb-tabbed-carousel__panel--active');
      currentPanel.hidden = true;
      // Reset stagger delays on deactivated panel
      currentPanel.querySelectorAll('.hb-product-card').forEach((card) => {
        card.style.animationDelay = '';
      });
    }

    // Activate new tab
    const newTab = tabs[index];
    const newPanel = panels[index];
    if (newTab) {
      newTab.classList.add('hb-tabbed-carousel__tab--active');
      newTab.setAttribute('aria-selected', 'true');
      newTab.setAttribute('tabindex', '0');
    }
    if (newPanel) {
      newPanel.hidden = false;
      // Apply staggered animation delays to cards
      newPanel.querySelectorAll('.hb-product-card').forEach((card, i) => {
        card.style.animationDelay = `${i * 60}ms`;
      });
      void newPanel.offsetHeight;
      newPanel.classList.add('hb-tabbed-carousel__panel--active');
    }

    // Switch CTA link to match active tab
    if (ctaLinks) {
      ctaLinks.forEach((link, i) => {
        link.hidden = i !== index;
      });
    }

    this.#activeIndex = index;
  }

  handleTabKey(data, event) {
    const { tabs } = this.refs;
    if (!tabs) return;

    let newIndex;
    if (event.key === 'ArrowRight') {
      newIndex = (this.#activeIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
      newIndex = (this.#activeIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      newIndex = 0;
    } else if (event.key === 'End') {
      newIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.switchTab(newIndex, event);
    tabs[newIndex].focus();
  }
}

if (!customElements.get('tabbed-carousel-component')) {
  customElements.define('tabbed-carousel-component', TabbedCarouselComponent);
}
